module.exports = __webpack_public_path__ + "img/Felicitaciones.9cc28b5c.png";